import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { MakePackages } from "@/features/settings/make-packages";
import { SettingsPage } from "@/features/settings/section";

export const Route = createFileRoute("/settings/packages")({
  component: MakePackagesPage,
});

/** Settings › Make packages (ADR 0014). */
function MakePackagesPage() {
  const { t } = useTranslation();
  return (
    <SettingsPage title={t("makePackages.title")} description={t("makePackages.body")}>
      <MakePackages />
    </SettingsPage>
  );
}
